import script from "./LeadsKanbanBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsKanbanBoard.vue?vue&type=script&setup=true&lang=js"

import "./LeadsKanbanBoard.vue?vue&type=style&index=0&id=405e33bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405e33bb"]])

export default __exports__